import React from 'react';
import MainPage from './pages/MainPage';
import HomePage from './pages/HomePage';
import SignUp from './pages/SignUp';
import { Routes, Route, Navigate } from "react-router-dom"
import Login from './pages/Login';
import PasswordReset from './pages/PasswordReset';
// import ActivateAccount from './pages/ActivateAccount'
import { AuthProvider } from './context/AuthContext';
import { AuthenticatedRoute } from './components/AuthenticatedRoute';

import './App.css'

function App() {
    return (
        <AuthProvider>
            <Routes>
                {/* Public routes - no authentication required */}
                <Route path="/login" element={<Login />} />
                <Route path="/" element={<HomePage />} />
                <Route path="/password-reset" element={<PasswordReset />} />
                {/* Must match the reset_url the backend puts in the email */}
                <Route path="/password-reset/confirm/:token" element={<PasswordReset />} />

                {/* Manager signup request form (public) */}
                <Route path="/signup" element={<SignUp />} />
                <Route path="/register" element={<SignUp />} />
                {/* Uncomment when these pages are created:
                <Route path="/activate" element={<ActivateAccount />} />
                <Route path="/activate-account" element={<ActivateAccount />} />
                */}
                
                {/* Protected routes - require authentication.
                    :section is the dashboard menu id (see config/sectionAccess.js);
                    MenuContext derives the selected screen from it. */}
                <Route path="/dashboard/:section?" element={
                    <AuthenticatedRoute>
                        <MainPage />
                    </AuthenticatedRoute>} />
                {/* Legacy URL kept alive as a redirect */}
                <Route path="/teacher-schedule" element={
                    <Navigate to="/dashboard/teacher-schedule" replace />} />
                
                {/* Catch-all route - protect any undefined routes */}
                <Route path="*" element={
                    <AuthenticatedRoute>
                        <Navigate to="/dashboard" replace />
                    </AuthenticatedRoute>} />
            </Routes>
        </AuthProvider>
    );
}

export default App
